module.exports = firebase.auth;